import { Typography } from '@material-ui/core';
import { DoneAll as DoneAllIcon, Done as DoneIcon } from '@material-ui/icons';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import { MessageStatus, MessagingProvider } from '@src/model/frontendmodel';
import { TimelineEvent } from '@src/types';
import { useMemo } from 'react';

type ChatMessageStatusProps = {
  message: TimelineEvent;
};

const ChatMessageStatus: React.FC<ChatMessageStatusProps> = ({ message }) => {
  // eslint-disable-next-line consistent-return
  const status = useMemo(() => {
    if (message?.readByContact) {
      return (
        <Typography style={{ fontSize: 12, lineHeight: 1, color: '#2196F3' }}>
          <DoneAllIcon fontSize="inherit" />{' '}
        </Typography>
      );
    }

    if (message?.receivedByContact) {
      return <DoneAllIcon style={{ fontSize: 12 }} />;
    }

    if (
      message?.deliveryAck &&
      message?.messagingProvider !== MessagingProvider.WHATSAPPOFF
    ) {
      return <DoneAllIcon style={{ fontSize: 12 }} />;
    }

    if (message?.deliveryAck || message.status === MessageStatus.IN_DELIVERY) {
      return <DoneIcon style={{ fontSize: 12 }} />;
    }

    return <WatchLaterIcon style={{ fontSize: 12 }} />;
  }, [message]);

  return <>{status}</>;
};

export default ChatMessageStatus;
